import React from 'react';
import styled from 'styled-components';

import PlayupThemeProvider from '../themes/PlayupThemeProvider';

export interface SwitchProps {
	active: boolean;
	name: string;
	small?: boolean;
	onChange: () => void;
	activeColor?: string;
	inactiveColor?: string;
}

const Switch = ({ active, name, small = false, onChange, activeColor, inactiveColor }: SwitchProps) => (
	<PlayupThemeProvider>
		<Wrapper
			onClick={onChange}
			$small={small}
			$active={active}
			$activeColor={activeColor}
			$inactiveColor={inactiveColor}
		>
			<input type="checkbox" name={name} />
			<label htmlFor={name} />
		</Wrapper>
	</PlayupThemeProvider>
);

const Wrapper = styled.div<{ $active: boolean; $small: boolean; $activeColor?: string; $inactiveColor?: string }>`
	position: relative;
	display: inline-block;
	vertical-align: middle;
	user-select: none;
	transition: all 0.2s ease;

	width: ${({ $small }) => ($small ? '1.5rem;' : '2.5rem')};

	input {
		position: absolute;
		right: ${({ $active, $small }) => ($active ? 0 : $small ? '0.5rem' : '1rem')};
		width: ${({ $small }) => ($small ? '1rem' : '1.5rem')};
		height: ${({ $small }) => ($small ? '1rem' : '1.5rem')};
		display: block;
		margin: 0;
		border-radius: 9999px;
		border-style: solid;
		border-width: ${({ $small }) => ($small ? '2px' : '3px')};
		border-color: ${({ theme, $active, $activeColor, $inactiveColor }) =>
			$active ? $activeColor ?? theme.colors.primary : $inactiveColor ?? theme.colors.greyR};
		background-color: ${({ theme }) => theme.colors.white};
		appearance: none;
		cursor: pointer;
		transition: all 0.2s ease;

		&:focus {
			outline: 2px solid transparent;
			outline-offset: 2px;
		}
	}

	label {
		display: block;
		height: ${({ $small }) => ($small ? '1rem' : '1.5rem')};
		overflow: hidden;
		border-radius: 9999px;
		cursor: pointer;
		background-color: ${({ theme, $active, $activeColor, $inactiveColor }) =>
			$active ? $activeColor ?? theme.colors.primary : $inactiveColor ?? theme.colors.greyR};
		transition: all 0.2s ease;
	}
`;

export default Switch;
